import image from '../assets/search-solid-cultured-50.png';

import styles from '../styles/base_components/Search.module.scss';

function Search(props) {
  function onChangeInput(event) {
    props.setInput(event.target.value);
  }

  return (
    <div className={styles.search + ' ' + props.className}>
      <input placeholder={props.placeholder} value={props.input} onChange={onChangeInput}/>
      <img src={image} alt='Search Solid'/>
    </div>
  );
}

export default Search;